(() => {
  const catalog = document.querySelector('.dd-catalog');
  if (!catalog) return;

  const sizeViews = { 24: 'ddpai-24', 36: 'ddpai-36' };
  const refreshSizeLinks = () => {
    catalog.querySelectorAll('a[data-page-size]').forEach((link) => {
      const url = new URL(window.location.href);
      url.searchParams.delete('page');
      url.searchParams.delete('section_id');
      const view = sizeViews[link.dataset.pageSize];
      if (view) url.searchParams.set('view', view);
      else url.searchParams.delete('view');
      url.hash = 'dd-catalog-top';
      link.href = url.href;
    });
  };

  const setLayout = (layout) => {
    catalog.dataset.layout = layout === 'list' ? 'list' : 'grid';
    catalog.querySelectorAll('button[data-layout]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.layout === catalog.dataset.layout));
    });
  };
  let savedLayout;
  try { savedLayout = localStorage.getItem('ddpai-catalog-layout'); } catch {}
  setLayout(savedLayout);
  catalog.querySelectorAll('button[data-layout]').forEach((button) => {
    button.addEventListener('click', () => {
      setLayout(button.dataset.layout);
      try { localStorage.setItem('ddpai-catalog-layout', catalog.dataset.layout); } catch {}
    });
  });

  // Native facets replace the grid, but the outer catalog retains its layout.
  // Preserve the alternate page-size template during sorting and filter removal.
  if (typeof FacetFiltersForm !== 'undefined' && !FacetFiltersForm.ddpaiPageSizeInstalled) {
    const renderPage = FacetFiltersForm.renderPage;
    FacetFiltersForm.renderPage = function (searchParams, event, updateURLHash = true) {
      const params = new URLSearchParams(searchParams);
      const view = new URLSearchParams(window.location.search).get('view');
      if (Object.values(sizeViews).includes(view) && !params.has('view')) params.set('view', view);
      return renderPage.call(this, params.toString(), event, updateURLHash);
    };
    FacetFiltersForm.ddpaiPageSizeInstalled = true;
  }

  // Keep the toolbar and the native mobile filter drawer on the same sort order.
  catalog.addEventListener('input', (event) => {
    if (!event.target.matches('select[name="sort_by"]')) return;
    catalog.querySelectorAll('select[name="sort_by"]').forEach((select) => {
      select.value = event.target.value;
    });
  }, true);

  refreshSizeLinks();
  const grid = catalog.querySelector('#ProductGridContainer');
  if (grid) new MutationObserver(refreshSizeLinks).observe(grid, { childList: true });
  window.addEventListener('popstate', refreshSizeLinks);
})();
